export const REQUIRED_STEP_READINGS = 3;
export const MAX_STEP_READINGS = 4;
export const MAX_DUPLICATES = 50;
export const MIN_DUPLICATES = 1;
export const MAX_DUPLICATES_LENGTH = 2;
export const CASE_LIMIT = 20;
export const CASE_INITIAL_OFFSET = 0;